import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// $FlowFixMe
import { useRef } from 'react';
import { ClickAwayListener, InputBase } from '@mui/material';
import { MUIButton } from 'app/components/Form/index.js';
import classes from 'app/components/Clipboard/ClipboardText.module.scss';
export function ClipboardText(props) {
    const { text, value, style } = props;
    const textRef = useRef();
    const selected = useRef(false);
    function selectAll(force) {
        if (textRef.current && (!selected.current || force)) {
            textRef.current.select();
            selected.current = true;
        }
    }
    function copy() {
        selectAll(true);
        const { ClipboardItem } = window;
        const item = new ClipboardItem({
            'text/plain': new Blob([value || text], { type: 'text/plain' }),
            'text/html': new Blob([value || text], { type: 'text/html' }),
        });
        navigator.clipboard.write([item]);
    }
    return (_jsx(ClickAwayListener, { onClickAway: () => {
            selected.current = false;
        }, children: _jsxs("div", { className: classes.container, style: style, onClick: () => selectAll(), children: [_jsx(InputBase, { inputRef: textRef, className: classes.text, value: text, onClick: copy, inputProps: { style: { fontFamily: 'monospace' } } }), _jsx(MUIButton, { tooltip: "Copy to clipboard", icon: "fas-copy", onClick: copy })] }) }));
}
